import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalizedConstants } from '../../i18n/useLocalizedConstants';
import { CURRENCY_SYMBOL } from '../../constants';
import { formatPrice } from '../../utils';
import './CustomerCard.css';

const CustomerCard = ({ 
  customer, 
  onEdit, 
  onCopy,
  onDelete, 
  isLoading, 
  formatDate,
  remainingAmount,
  permissions = {}
}) => {
  const { t } = useTranslation();
  const { ORDER_STATUS_LABELS } = useLocalizedConstants();
  return (
    <div className="customer-card">
      <div className="card-header">
        <div className="customer-name">
          <h4>{customer.name}</h4>
        </div>
        <span className={`status-badge status-${customer.orderStatus || 'new_order'}`}>
          {ORDER_STATUS_LABELS[customer.orderStatus || 'new_order']}
        </span>
      </div>
      
      <div className="card-content">
        <div className="card-info">
          <div className="info-item">
            <i className="fas fa-phone"></i>
            <span>{customer.phone1}</span>
          </div>
          
          {customer.phone2 && (
            <div className="info-item">
              <i className="fas fa-phone"></i>
              <span>{customer.phone2}</span>
            </div>
          )}
          
          {customer.email && (
            <div className="info-item">
              <i className="fas fa-envelope"></i>
              <span>{customer.email}</span>
            </div>
          )}
          
          <div className="info-item">
            <i className="fas fa-calendar"></i>
            <span>Sipariş: {formatDate(customer.orderDate)}</span>
          </div>
          
          <div className="info-item">
            <i className="fas fa-calendar-check"></i>
            <span>Teslimat: {formatDate(customer.deliveryDate)}</span>
          </div>
          
          {customer.address && (
            <div className="info-item address">
              <i className="fas fa-map-marker-alt"></i>
              <span>{customer.address}</span>
            </div>
          )}
          
          {customer.notes && (
            <div className="info-item notes">
              <i className="fas fa-sticky-note"></i>
              <span>{customer.notes}</span>
            </div>
          )}

          <div className="info-item remaining-payment">
            <i className="fas fa-money-bill-wave"></i>
            <span>
              {t('customers.table.remainingPayment')}: {
                remainingAmount !== undefined ? (
                  remainingAmount === -1 ? (
                    <span className="no-order">
                      <i className="fas fa-minus-circle"></i> {t('customers.table.noOrder')}
                    </span>
                  ) : (customer.isPaymentCompleted || remainingAmount === 0) ? (
                    <span className="payment-completed">
                      <i className="fas fa-check-circle"></i> {t('customers.table.paymentReceived')}
                    </span>
                  ) : (
                    <span className="remaining-amount">{formatPrice(remainingAmount)} {CURRENCY_SYMBOL}</span>
                  )
                ) : (
                  <span className="loading-amount">{t('customers.table.calculating')}</span>
                )
              }
            </span>
          </div>
        </div>
      </div>
      
      <div className="card-actions">
        {/* Düzenleme butonu - Montajcı da görür (durum güncelleme için) */}
        <button 
          onClick={() => onEdit(customer)}
          className="edit-btn"
          disabled={isLoading}
          title={permissions?.canEditCustomer ? "Düzenle" : "Detaylar"}
        >
          <i className={`fas ${permissions?.canEditCustomer ? 'fa-edit' : 'fa-eye'}`}></i>
        </button>
        
        {/* Kopyalama butonu - Montajcı göremez */}
        {permissions?.canCreateCustomer && (
          <button 
            onClick={() => onCopy(customer)}
            className="copy-btn"
            disabled={isLoading}
            title="Müşteriyi Kopyala"
          >
            <i className="fas fa-copy"></i>
          </button>
        )}
        
        {/* Silme butonu - Montajcı göremez */}
        {permissions?.canDeleteCustomer && (
          <button 
            onClick={() => onDelete(customer)}
            className="delete-btn"
            disabled={isLoading}
            title="Sil"
          >
            <i className="fas fa-trash"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomerCard; 